<template>
    <img class="w-auto" :src="url" alt="Figurinha" :class="props.preview ? 'max-h-20' : 'max-h-40'" loading="lazy"/>
</template>

<script setup lang="ts">
import {ref} from "vue";

const props = defineProps(['data', 'preview'])
const url = ref<string>('')

try{
    const parsed = JSON.parse(props.data)
    url.value = parsed.url
} catch (e) {
    url.value = props.data
}
</script>

<style scoped>

</style>